import axios from '../axios';

export const SESSION_TIMEOUT_CHECK_URL = '/api/session';

export default {
  session() {
    return axios.get(SESSION_TIMEOUT_CHECK_URL);
  },
};
